<template>
    <form class="o-users">
        <m-title title="Dodaj użytkownika" />
        <o-user-add-form
            :first_name.sync="first_name"
            :last_name.sync="last_name"
            :email.sync="email"
            :phone.sync="phone"
            :counties.sync="counties"
            :devices_number.sync="devices_number"
            :customer.sync="customer"
            ref="userAddForm"
        />
        <div class="l-row">
            <div class="l-row__column">
                <a-button
                    type="fullwidth"
                    :submit="true"
                    :is-processing="userStatus === 'saving'"
                    @click.prevent="handleSubmit"
                >
                    Wyślij link aktywacyjny
                </a-button>
            </div>
        </div>
    </form>
</template>

<script>
import OUserAddForm from '@/components/OUserAddForm'

export default {
    metaInfo: {
        title: 'Dodaj użytkownika'
    },
    components: {
        OUserAddForm
    },
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            counties: [],
            devices_number: 1,
            customer: 'customer'
        }
    },
    computed: {
        userStatus() {
            return this.$store.getters.userStatus
        }
    },
    methods: {
        handleSubmit() {
            if (!this.$refs.userAddForm.validateForm()) return false

            this.$store
                .dispatch('addUser', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    counties: this.counties.map(item => item.id),
                    devices_number: this.devices_number
                })
                .then(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: `Dodano nowego użytkownika ${this.first_name} ${this.last_name}`
                    })
                    this.$router.push({ name: 'users' })
                })
                .catch(error => {
                    let errorMessage = 'Wystąpił błąd. '
                    const { errors } = error.response.data.data
                    if (errors) {
                        Object.values(errors).forEach(singleFieldErrors => {
                            const singleFieldErrorMsg = Object.values(
                                singleFieldErrors
                            ).join(', ')
                            errorMessage += `${singleFieldErrorMsg}. `
                        })
                    }
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: errorMessage
                    })
                })
        }
    }
}
</script>
